import { TextField } from "@material-ui/core";
import NumberFormat from "react-number-format";

const PriceInput = ({ error, input, onValueChange, label = "Valor", required = false }) => {
  return (
    <NumberFormat
      error={error}
      required={required}
      customInput={TextField}
      variant="outlined"
      label={label}
      className="col-4 fz-16 text-cl-dark-jungle-green ff-univanova mb-3"
      thousandSeparator={"."}
      decimalSeparator=","
      prefix={"R$ "}
      decimalScale={2}
      fixedDecimalScale={true}
      name="price"
      defaultValue={input || 0}
      onValueChange={onValueChange}
    />
  );
};

export default PriceInput;
